import * as i0 from '@angular/core';
import { input, model, numberAttribute, output, signal, viewChild, TemplateRef, Directive, inject, PLATFORM_ID, booleanAttribute, contentChildren, computed, effect, untracked, afterNextRender } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ViewportScroller, isPlatformServer } from '@angular/common';
import { toObservable, outputFromObservable, outputToObservable } from '@angular/core/rxjs-interop';
import { Router, ActivatedRoute } from '@angular/router';
import { computedPrevious } from 'ngxtension/computed-previous';
import { explicitEffect } from 'ngxtension/explicit-effect';
import { filter, Subscription, first, fromEvent, tap, throttleTime } from 'rxjs';
const _c0 = ["globalSummaryTemplate"];
const _c1 = ["summaryTemplate"];
const _c2 = ["thanksTemplate"];
const CHECKOUT_STEP_TOKEN = 'CHECKOUT_STEP_TOKEN';
let CheckoutStepComponent = /*#__PURE__*/(() => {
  class CheckoutStepComponent {
    constructor() {
      this.title = input('');
      this.formData = model({});
      this.submitData = model({});
      this.globalSummarySorting = input(0, {
        transform: numberAttribute
      });
      this.summarySorting = input(0, {
        transform: numberAttribute
      });
      this.thanksSorting = input(0, {
        transform: numberAttribute
      });
      this.previousStep = output();
      this.stepComplete = output();
      this.done = output();
      this.linkToThisStep = output();
      this.previousSummaryTemplateRefs = signal([]);
      this.previousThanksTemplateRefs = signal([]);
      this.isActive = signal(false);
      this.globalSumaryTemplateRef = viewChild('globalSummaryTemplate', {
        read: TemplateRef
      });
      this.summaryTemplateRef = viewChild('summaryTemplate', {
        read: TemplateRef
      });
      this.thanksTemplateRef = viewChild('thanksTemplate', {
        read: TemplateRef
      });
      this.form = new UntypedFormGroup({});
      this.saveState = async () => true;
    }
    setSaveStateMethod(saveState) {
      this.saveState = saveState;
    }
    setFormData(data) {
      this.formData.set(data);
    }
    setSubmitData(data) {
      this.submitData.set(data);
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
    async onWrapperReady(evt) {}
    showInStepperMenu() {
      return !this.isDataStep();
    }
    showStepperMenu() {
      return true;
    }
    showSidebar() {
      return true;
    }
    getStepName() {
      return `${this.title}`;
    }
    isValid() {
      return this.form.valid;
    }
    canActivate() {
      return true;
    }
    activate() {
      if (this.isDataStep()) return this.complete();
      this.isActive.set(true);
    }
    deactivate() {
      this.isActive.set(false);
    }
    isDataStep() {
      return false;
    }
    complete() {
      this.stepComplete.emit(this.form.value);
    }
    emitDone(id, wasRestored) {
      this.done.emit({
        id,
        formData: wasRestored ? this.formData : this.form.value,
        wasRestored
      });
    }
    getSummaryTemplateRef() {
      const ref = this.summaryTemplateRef();
      if (!ref) return;
      return {
        templateRef: ref,
        sorting: this.summarySorting()
      };
    }
    getThanksTemplateRef() {
      const ref = this.thanksTemplateRef();
      if (!ref) return;
      return {
        templateRef: ref,
        sorting: this.thanksSorting()
      };
    }
    getGlobalSummaryTemplateRef() {
      const ref = this.globalSumaryTemplateRef();
      if (!ref) return;
      return {
        templateRef: ref,
        sorting: this.globalSummarySorting()
      };
    }
    setPreviousSummaryTemplateRefs(refs) {
      this.previousSummaryTemplateRefs.set(refs);
    }
    setPreviousThanksTemplateRefs(refs) {
      this.previousThanksTemplateRefs.set(refs);
    }
    getSubmitData() {
      return this.form.value;
    }
    static {
      this.ɵfac = function CheckoutStepComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutStepComponent)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: CheckoutStepComponent,
        viewQuery: function CheckoutStepComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.globalSumaryTemplateRef, _c0, 5, TemplateRef);
            i0.ɵɵviewQuerySignal(ctx.summaryTemplateRef, _c1, 5, TemplateRef);
            i0.ɵɵviewQuerySignal(ctx.thanksTemplateRef, _c2, 5, TemplateRef);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(3);
          }
        },
        inputs: {
          title: [1, "title"],
          formData: [1, "formData"],
          submitData: [1, "submitData"],
          globalSummarySorting: [1, "globalSummarySorting"],
          summarySorting: [1, "summarySorting"],
          thanksSorting: [1, "thanksSorting"]
        },
        outputs: {
          formData: "formDataChange",
          submitData: "submitDataChange",
          previousStep: "previousStep",
          stepComplete: "stepComplete",
          done: "done",
          linkToThisStep: "linkToThisStep"
        }
      });
    }
  }
  return CheckoutStepComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class WrapperReadyEvent {
  constructor(wasRestored) {
    this.wasRestored = wasRestored;
    this._preventDefault = false;
  }
  preventDefault() {
    this._preventDefault = true;
  }
  isDefaultPrevented() {
    return this._preventDefault;
  }
}
let CheckoutWrapperComponent = /*#__PURE__*/(() => {
  class CheckoutWrapperComponent {
    constructor() {
      this.platformId = inject(PLATFORM_ID);
      this.viewportScroller = inject(ViewportScroller);
      this.router = inject(Router);
      this.activatedRoute = inject(ActivatedRoute);
      this.formDataChange = output();
      this.identifier = input.required();
      this.formData = model({});
      this.scrollToTopDisabled = input(false, {
        transform: booleanAttribute
      });
      this.disableBackButtonHandling = input(false, {
        transform: booleanAttribute
      });
      this.errorText = signal('');
      this.submitData = signal({});
      this.currentStepIndex = signal(-1);
      this.loading = signal(false);
      this.querySteps = contentChildren(CHECKOUT_STEP_TOKEN);
      this.steps = computed(() => {
        const querySteps = this.querySteps();
        const stepArr = [];
        for (const [index, step] of querySteps.entries()) {
          const data = {
            id: index + 1,
            name: '',
            showStepperMenu: step.showStepperMenu(),
            showInStepperMenu: step.showInStepperMenu(),
            showSidebar: step.showSidebar(),
            isDataStep: step.isDataStep(),
            ref: step
          };
          if (data.showStepperMenu && data.showInStepperMenu) {
            data.name = step.getStepName();
          }
          this.handlePreviousStep(data);
          this.handleStepCompleted(data);
          this.handleLinkToThisStep(data);
          stepArr.push(data);
        }
        return stepArr;
      });
      this.previousSteps = computedPrevious(this.steps);
      this.stepsForStepper = computed(() => {
        const steps = this.steps();
        return steps.filter(s => s.showStepperMenu && s.showInStepperMenu).map(s => ({
          id: s.id,
          label: s.name,
          labelWidth: 0
        }));
      });
      this.currentStepperIndex = computed(() => {
        const currentStep = this.currentStep();
        const stepsForStepper = this.stepsForStepper();
        return stepsForStepper.findIndex(stepperStep => currentStep?.id === stepperStep.id);
      });
      this.currentStep = computed(() => {
        const steps = this.steps();
        const currentStepIndex = this.currentStepIndex();
        if (!(steps.length > 0 && currentStepIndex >= 0 && currentStepIndex < steps.length)) return;
        return steps[currentStepIndex];
      });
      this.data = computed(() => {
        return {
          currentStep: this.currentStep(),
          stepForStepper: this.stepsForStepper(),
          stepperIndex: this.currentStepperIndex()
        };
      });
      this.completed = computed(() => this.currentStepIndex() === this.steps().length - 1);
      this.globalSummaryTemplateRefs = computed(() => {
        const summaryRefs = [];
        const steps = this.steps();
        const currentStepIndex = this.currentStepIndex();
        for (let i = 0; i < steps.length && i <= currentStepIndex; i++) {
          const summary = steps[i].ref.getGlobalSummaryTemplateRef();
          if (summary) {
            summaryRefs.push(summary);
          }
        }
        return this.getSortedTemplateRefs(summaryRefs);
      });
      this.summeryRefs = computed(() => {
        const summaryRefs = [];
        const steps = this.steps();
        const currentStepIndex = this.currentStepIndex();
        for (let i = 0; i < steps.length && i < currentStepIndex; i++) {
          const summary = steps[i].ref.getSummaryTemplateRef();
          if (summary) {
            summaryRefs.push(summary);
          }
        }
        return summaryRefs;
      });
      this.sortedSummeryRefs = computed(() => this.getSortedTemplateRefs(this.summeryRefs()));
      this.previousThanksTemplates = computed(() => {
        const thanksRefs = [];
        const steps = this.steps();
        const currentStepIndex = this.currentStepIndex();
        for (let i = 0; i < steps.length && i <= currentStepIndex; i++) {
          const thanks = steps[i].ref.getThanksTemplateRef();
          if (thanks) {
            thanksRefs.push(thanks);
          }
        }
        return thanksRefs;
      });
      this.sortedPreviousThanksTemplates = computed(() => this.getSortedTemplateRefs(this.previousThanksTemplates()));
      this.isFirstStep = computed(() => {
        const firstNonDataStepIndex = this.steps().findIndex(step => !step.isDataStep);
        return this.currentStepIndex() === firstNonDataStepIndex;
      });
      this.indexChangeEffect = explicitEffect([this.currentStep], ([step]) => {
        if (!step) return;
        this.loading.set(true);
        this.setterFuntions(step);
        step.ref.activate();
        this.loading.set(false);
        this.scrollPageToTop();
      }, {
        allowSignalWrites: true
      });
      this.stepTransformEffect = effect(() => {
        const stepArr = this.steps();
        const previousSteps = untracked(() => this.previousSteps());
        const currentStepIndex = untracked(() => this.currentStepIndex());
        let newStepIndex = 0;
        let previousStep;
        stepArr.forEach(step => {
          previousSteps.flat();
          if (previousSteps.length > 0 && previousSteps[currentStepIndex]?.ref === step.ref) {
            previousStep = step.ref;
            newStepIndex = step.id - 1;
          }
        });
        if (previousSteps.length > 0 && stepArr.length > 0) {
          if (stepArr[currentStepIndex].ref !== stepArr[newStepIndex].ref) stepArr[currentStepIndex].ref.deactivate();
          if (previousStep && previousStep !== stepArr[newStepIndex].ref) previousStep.deactivate();
          untracked(() => {
            this.currentStepIndex.set(newStepIndex);
          });
        }
      });
      this.stepsObservable = toObservable(this.steps);
      this.stepChange = outputFromObservable(toObservable(this.currentStepIndex));
      this.formComplete = outputFromObservable(toObservable(this.completed).pipe(filter(v => !!v)));
      this.subs = new Subscription();
      this.storageKey = 'pxCheckoutWrapperState';
      afterNextRender(() => {
        this.stepsObservable.pipe(filter(steps => steps.length > 0), first()).subscribe(steps => {
          const restored = this.restoreState();
          const wrapperReadyEvt = new WrapperReadyEvent(restored);
          this.initSteps(steps, wrapperReadyEvt);
          if (!restored && !wrapperReadyEvt.isDefaultPrevented()) {
            this.activateStep(0);
          }
          this.setupBackButtonHandling();
        });
      });
    }
    scrollPageToTop() {
      if (this.scrollToTopDisabled()) return;
      this.viewportScroller.scrollToPosition([0, 0]);
    }
    getStorageKey() {
      return `${this.storageKey}_${this.identifier}`;
    }
    setterFuntions(step) {
      step.ref.setPreviousSummaryTemplateRefs(this.sortedSummeryRefs());
      step.ref.setPreviousThanksTemplateRefs(this.sortedPreviousThanksTemplates());
      step.ref.setSaveStateMethod(async () => this.saveState());
      for (const step of this.steps()) {
        step.ref.setFormData(this.formData());
      }
      step.ref.setSubmitData(this.submitData());
    }
    saveState() {
      if (isPlatformServer(this.platformId)) {
        return false;
      }
      sessionStorage.setItem(this.getStorageKey(), JSON.stringify({
        currentStepIndex: this.currentStepIndex(),
        formData: this.formData,
        submitData: this.submitData
      }));
      return true;
    }
    restoreState() {
      if (isPlatformServer(this.platformId)) return false;
      const state = JSON.parse(sessionStorage.getItem(this.getStorageKey()) || '{}');
      let restored = false;
      if (state?.formData && state?.submitData && state?.currentStepIndex) {
        this.formData = state.formData;
        this.submitData = state.submitData;
        this.currentStepIndex.set(state.currentStepIndex);
        restored = true;
      }
      sessionStorage.removeItem(this.getStorageKey());
      return restored;
    }
    nextStep() {
      if (this.completed()) return;
      this.activateStep(this.currentStepIndex() + 1);
    }
    activateStepById(id, ignoreValidation = false) {
      const steps = this.steps();
      this.activateStep(steps.findIndex(step => step.id === id), false, ignoreValidation);
    }
    checkCanActivateStep(step) {
      step.ref.setFormData(this.formData());
      return step.ref.canActivate();
    }
    deactivateCurrentStep(index, currentIdx, steps) {
      if (currentIdx !== index && currentIdx >= 0) {
        steps[currentIdx].ref.deactivate();
      }
    }
    activateStep(index, clearErrorText = false, ignoreValidation = false) {
      const steps = this.steps();
      if (index < 0 || index >= steps.length) {
        return;
      }
      const currentIdx = this.currentStepIndex();
      if (!ignoreValidation && currentIdx >= 0 && index > currentIdx) {
        for (let i = currentIdx; i < index; i++) {
          if (!steps[i].ref.isValid()) return;
        }
      }
      if (!this.checkCanActivateStep(steps[index])) return;
      this.deactivateCurrentStep(index, currentIdx, steps);
      this.currentStepIndex.set(index);
      if (clearErrorText) {
        this.errorText.set('');
      }
    }
    async previousStep(isError = false) {
      if (this.isFirstStep()) {
        window.history.go(-1);
        return;
      }
      if (this.completed() && !isError) {
        location.reload();
        return;
      }
      this.activateStep(this.getPreviousNonDataStepIndex());
    }
    getPreviousNonDataStepIndex() {
      const steps = this.steps();
      const currentIdx = this.currentStepIndex();
      for (let i = currentIdx - 1; i >= 0; i--) {
        if (!steps[i].isDataStep) return i;
      }
      return currentIdx;
    }
    async initSteps(steps, wrapperReadyEvt) {
      for (const step of steps) {
        if (wrapperReadyEvt.wasRestored) {
          step.ref.setFormData(this.formData());
          if (step.id <= this.currentStepIndex()) {
            step.ref.emitDone(step.id, true);
          }
        }
        await step.ref.onWrapperReady(wrapperReadyEvt);
      }
    }
    handlePreviousStep(step) {
      this.subscribe(outputToObservable(step.ref.previousStep), async error => {
        await this.previousStep(!!error);
        this.errorText.set(error || '');
      });
    }
    handleLinkToThisStep(step) {
      this.subscribe(outputToObservable(step.ref.linkToThisStep), async val => {
        this.activateStepById(step.id, !!val);
      });
    }
    handleStepCompleted(step) {
      this.subscribe(outputToObservable(step.ref.stepComplete), async data => {
        this.formData.set({
          ...this.formData(),
          ...data
        });
        const submitData = await step.ref.getSubmitData();
        this.submitData.set({
          ...this.submitData(),
          ...submitData
        });
        this.formDataChange.emit(this.formData());
        step.ref.emitDone(step.id, false);
        this.errorText.set('');
        if (!this.completed()) {
          await this.nextStep();
        }
      });
    }
    async setupBackButtonHandling() {
      if (isPlatformServer(this.platformId) || this.disableBackButtonHandling()) return;
      const url = this.router.createUrlTree(['.'], {
        relativeTo: this.activatedRoute,
        queryParamsHandling: 'preserve'
      }).toString();
      history.pushState('', '', url);
      this.historyBackSub = fromEvent(window, 'popstate').pipe(tap(evt => {
        if (this.isFirstStep() || this.completed()) {
          return;
        }
        evt.preventDefault();
        window.history.go(1);
      }), throttleTime(300)).subscribe(async () => {
        await this.previousStep();
      });
    }
    subscribe(ob, cb) {
      this.subs.add(ob.subscribe(v => cb(v)));
    }
    ngOnDestroy() {
      this.subs.unsubscribe();
      this.historyBackSub?.unsubscribe();
    }
    getSortedTemplateRefs(refs) {
      return refs.sort((a, b) => {
        if (a.sorting === b.sorting) {
          return 0;
        }
        return a.sorting < b.sorting ? 1 : -1;
      }).map(r => r.templateRef);
    }
    static {
      this.ɵfac = function CheckoutWrapperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutWrapperComponent)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: CheckoutWrapperComponent,
        contentQueries: function CheckoutWrapperComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuerySignal(dirIndex, ctx.querySteps, CHECKOUT_STEP_TOKEN, 4);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          identifier: [1, "identifier"],
          formData: [1, "formData"],
          scrollToTopDisabled: [1, "scrollToTopDisabled"],
          disableBackButtonHandling: [1, "disableBackButtonHandling"]
        },
        outputs: {
          formDataChange: "formDataChange",
          formData: "formDataChange",
          stepChange: "stepChange",
          formComplete: "formComplete"
        }
      });
    }
  }
  return CheckoutWrapperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CHECKOUT_STEP_TOKEN, CheckoutStepComponent, CheckoutWrapperComponent, WrapperReadyEvent };
